import { SwProjectView } from "~/backendApis/viewModel/swProject"
import { ApiClient } from "~/clApi/main/foundation/ApiClient"

const basePath = "/project/user/project/sw_project"

export const read = {
  showSwProject: (params: { projectId: string }) =>
    new ApiClient<SwProjectView>().get(`${basePath}/show/${params.projectId}`),
}
